import { neutrals, brand } from 'src/theme/colors';
import { StyleSheet } from 'react-native';
import { FOCUS_COLOR } from 'src/theme-v2/focus';

const sharedStyle = StyleSheet.create({
  border: {
    borderWidth: 1,
    borderColor: `${neutrals.white}00`,
    borderRadius: 25,
  },
  borderSelected: {
    borderColor: brand.main.water,
  },
  borderFocus: {
    borderColor: FOCUS_COLOR,
  },
  textTitle: {
    fontWeight: 700,
    fontSize: 20,
    lineHeight: 26,
    color: neutrals.neutralGrays.graphite,
  },
  textPrice: {
    fontWeight: 700,
    fontSize: 14,
    lineHeight: 21,
    color: neutrals.neutralGrays.graphite,
  },
  description: {
    flexDirection: 'row',
    gap: 8,
    minHeight: 55,
    maxHeight: 65,
  },
  textDescription: {
    fontWeight: 400,
    fontSize: 14,
    lineHeight: 16,
    color: neutrals.neutralGrays.cement,
  },
  radioButton: {
    width: 23,
    height: 23,
    borderWidth: 2,
    borderRadius: 22,
    borderColor: neutrals.neutralGrays.aluminium,
    justifyContent: 'center',
    alignItems: 'center',
  },
  radioButtonSelected: {
    width: 11,
    height: 11,
    borderRadius: 11,
    backgroundColor: brand.main.water,
  },
});

export const styleDesktop = StyleSheet.create({
  ...sharedStyle,
  card: {
    backgroundColor: neutrals.white,
    flexDirection: 'column',
    width: 191,
    height: 317,
    gap: 16,
    paddingBottom: 16,
    borderRadius: 24,
    shadowColor: `${neutrals.black}26`,
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowRadius: 12,
    alignItems: 'center',
  },
  image: {
    width: 191,
    height: 161,
    backgroundColor: '#CCCCCC',
    borderRadius: 24,
  },
  textBadge: {
    fontWeight: 700,
    fontSize: 14,
    lineHeight: 16,
    color: neutrals.white,
  },
  badge: {
    position: 'absolute',
    top: 8,
    left: 8,
    flexDirection: 'row',
    paddingHorizontal: 10,
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 1,
    paddingVertical: 5,
    borderRadius: 24,
    gap: 4,
    backgroundColor: brand.main.water,
  },
  icon: {
    width: 18,
    height: 18,
  },
  textContainer: {
    width: '100%',
    flex: 1,
    justifyContent: 'flex-start',
    gap: 8,
    paddingHorizontal: 16,
  },
});

export const styleMobile = StyleSheet.create({
  ...sharedStyle,
  card: {
    backgroundColor: neutrals.white,
    flexDirection: 'row',
    width: '100%',
    gap: 16,
    borderRadius: 24,
    shadowColor: `${neutrals.black}26`,
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowRadius: 12,
    alignItems: 'center',
  },
  image: {
    width: 162,
    height: 136,
    backgroundColor: '#CCCCCC',
    borderRadius: 24,
  },
  textBadge: {
    fontWeight: 700,
    fontSize: 12,
    lineHeight: 14,
    color: neutrals.white,
  },
  badge: {
    position: 'absolute',
    top: 6,
    left: 6,
    flexDirection: 'row',
    paddingHorizontal: 10,
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 1,
    paddingVertical: 4,
    borderRadius: 24,
    gap: 4,
    backgroundColor: brand.main.water,
  },
  icon: {
    width: 15,
    height: 15,
  },
  textContainer: {
    width: '100%',
    flex: 1,
    justifyContent: 'flex-start',
    gap: 8,
    paddingRight: 16,
  },
});
